var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcRefreshLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.556,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.778 7A6.209 6.209 0 017 .778c2.767 0 4.84 1.153 6.222 3.46m0 0V1.125m0 3.111H10.46",
    stroke: "#000139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.556 9.763v3.11M13.222 7c0 3.435-2.767 6.222-6.176 6.222-2.273 0-4.103-1.153-5.49-3.46h2.791",
    stroke: "#A0A3BD"
  }))));
}

export default SvgIcRefreshLight;